import { cn } from 'app/utils/styles.utils';

type SpacerProps = {
  className?: string;
  size?: number | string;
};

export const Spacer = ({size = 0, className}: SpacerProps) => {
  const formattedSize = typeof size === 'number' ? `${size}px` : size;

  return (
    <div
      className={cn('flex w-full', className)}
      style={{
        marginTop: formattedSize,
        marginBottom: formattedSize,
      }}
    />
  );
};
